export default __webpack_public_path__ + "static/media/daksh.b52a8f37.jpg";